import "./blogs.css";
import { Link } from "react-router-dom";
import { blogPosts } from "../../../data/blog";
import { getBlogImage } from "../../../data/blogImages";

const FEATURED_COUNT = 4;

const featuredPosts = blogPosts
  .filter((post) => post.type === "blog")
  .slice(0, FEATURED_COUNT);

const cleanExcerpt = (text = "") => text.replace(/\s*\[\.\.\.\]$/, "...");

function ArrowIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="17"
      height="17"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M7 17 17 7M7 7h10v10"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function Blogs() {
  return (
    <section className="blogs-section" aria-labelledby="blogs-title">
      <div className="blogs-container">
        <header className="blogs-header">
          <div className="blogs-heading-group">
            <span className="blogs-eyebrow">
              <span className="blogs-eyebrow-dot" aria-hidden="true" />
              Blogs &amp; Media
            </span>

            <h2 className="blogs-title" id="blogs-title">
              <span className="blogs-title-accent">Insights</span> From the Team
              Building AI's Data Layer
            </h2>
          </div>

          <Link to="/resources/blogs" className="blogs-view-all">
            View All Articles
            <ArrowIcon />
          </Link>
        </header>

        <div className="blogs-grid">
          {featuredPosts.map((post) => (
            <Link
              className="blog-card"
              key={post.slug}
              to={`/resources/blogs/${post.slug}`}
            >
              <div className="blog-image-wrap">
                {getBlogImage(post) ? (
                  <img
                    className="blog-image"
                    src={getBlogImage(post)}
                    alt={post.imageAlt}
                    loading="lazy"
                  />
                ) : (
                  <div className="blog-image-placeholder" />
                )}

                <span className="blog-image-arrow">
                  <ArrowIcon />
                </span>
              </div>

              <div className="blog-content">
                <span className="blog-category">
                  {post.category.toUpperCase()}
                </span>

                <h3 className="blog-card-title">{post.title}</h3>

                <p className="blog-description">
                  {cleanExcerpt(post.excerpt)}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
